import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { siteUserEditGroupMembership } from '../actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserEditGroupMembershipAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserEditGroupMembership,
  translateName: Messages.groupMembership_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return true;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return targetItems.length > 0;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserEditGroupMembership(targetItems)
};
